import { LOCALES } from "../i18n/messages";

export const PAGE_DEFS = [
  { key: "home", slug: "" },
  { key: "auction", slug: "auction" },
  { key: "auctionDetail", slug: "auction/:auctionId" },
  { key: "market", slug: "market" },
  { key: "detail", slug: "detail" },
  { key: "rwa", slug: "rwa" },
  { key: "settlement", slug: "settlement" },
  { key: "profile", slug: "profile" },
  { key: "studio", slug: "studio" },
  { key: "blog", slug: "blog" },
  { key: "blogPost", slug: "blog/:postId" },
];

export function localePrefix(locale) {
  return LOCALES[locale]?.prefix || "";
}

export function buildPath(locale, slug = "") {
  const prefix = localePrefix(locale);
  if (!prefix) {
    if (!slug) return "/";
    return `/${slug}`;
  }
  if (!slug) return `/${prefix}`;
  return `/${prefix}/${slug}`;
}

export function stripLangFromPath(pathname = "/") {
  const segments = pathname.split("/").filter(Boolean);
  if (!segments.length) {
    return { locale: "zh-Hans", localPath: "/" };
  }
  const hit = Object.entries(LOCALES).find(([, info]) => info.prefix === segments[0]);
  if (!hit) {
    return { locale: "zh-Hans", localPath: pathname };
  }
  const locale = hit[0];
  const rest = segments.slice(1);
  const localPath = rest.length ? `/${rest.join("/")}` : "/";
  return { locale, localPath };
}
